import React from "react";
import { Tabs } from "antd5";

import CognismContactsTable from "components/contacts/cognism/CognismContactsTable";
import ContactsTable from "components/contacts/ContactsTable";
import { useUnifiedContacts } from "lib/hooks/useUnifiedContacts";
import { BuyerDetails } from "lib/types/models";
import { HandleNavigation, SecondaryTab } from "../types";
import { ProcurementContacts } from "./Procurement";

type PanelProps = {
  buyer: BuyerDetails;
  handleTabNavigation: HandleNavigation;
  activeTab: SecondaryTab | null;
};

const CONTEXT_SOURCE = "Decision maker contacts table";

export default function ContactsPanel({
  buyer,
  handleTabNavigation,
  activeTab,
}: PanelProps): JSX.Element {
  const unifiedContactsEnabled = useUnifiedContacts();

  // Both sub-tabs exist in either version — only the Decision-makers tab's contents change.
  // Procurement contacts are notice-derived and need no CONTACTS entitlement, so they stay
  // available to everyone, including companies that see the paywall on Decision-makers.
  const decisionMakers = unifiedContactsEnabled ? (
    <CognismContactsTable
      embedConfig={{
        lockedBuyerGuids: [buyer.guid],
        defaultPageSize: 10,
        urlStateKey: "cognismContactFilters",
        tableKey: "buyer-contacts-table",
        contextSource: CONTEXT_SOURCE,
      }}
    />
  ) : (
    <ContactsTable
      tableKey="buyer-details-contacts-table"
      buyerId={buyer.guid}
      contextSource={CONTEXT_SOURCE}
      pageSize={10}
      showDropdownFilters={true}
      showAllFiltersDrawer={false}
    />
  );

  return (
    <Tabs
      activeKey={activeTab ? activeTab : SecondaryTab.CONTACTS}
      onChange={(key) => handleTabNavigation(key as SecondaryTab)}
      items={[
        {
          key: SecondaryTab.CONTACTS,
          label: "Decision-makers",
          children: decisionMakers,
        },
        {
          key: SecondaryTab.PROCUREMENT,
          label: "Procurement",
          children: <ProcurementContacts buyer={buyer} />,
        },
      ]}
    />
  );
}
